import { AlertContext } from "contexts/AlertContext"
import Modal from "components/Modal/Modal"
import { DELETE } from "api/request"
import { useContext } from "react"
import * as url from 'api/urls'

interface DeleteBoardModalProps {
  onClose: () => void
  onReload: () => void
  boardId: string | undefined
}

const DeleteBoardModal: React.FC<DeleteBoardModalProps> = ({ boardId, onClose, onReload }) => {
  const { showAlert } = useContext(AlertContext)

  const handleSubmit = async () => {
    try {
      const response = await DELETE(url.updatedBoard(boardId))
      if (response.ok) {
        showAlert('Usunięto pomnik', 'success')
        onReload()
        onClose()
      } else {
        onClose()
        showAlert('Wystąpił błąd', 'error')
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Modal
      icon='trash'
      onClose={onClose}
      title='Chcesz usunąć pomnik?'
      primaryButton={'Usuń'} primaryButtonAction={() => handleSubmit()}
      secondaryButton={'Nie usuwaj'} secondaryButtonAction={'close'}>
      <div className="center">Klikając: "Usuń" usuniesz pomnik na zawsze</div>
    </Modal>
  )
}

export default DeleteBoardModal